import { createSlice } from "@reduxjs/toolkit";

const alertEventsSlice = createSlice({
  name: "alertEvents",
  initialState: {
    alertEvents: null,
    notificationsCount: [],
    isFetching: false,
    error: false,
  },
  reducers: {
    alertEventsStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },

    alertEventsSuccess: (state, action) => {
      state.alertEvents = action.payload;
      state.isFetching = false;
      state.error = false;
    },

    notificationsCountSuccess: (state, action) => {
      state.notificationsCount = Array.isArray(action.payload)
        ? action.payload
        : [];
      state.isFetching = false;
      state.error = false;
    },

    alertEventsFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },

    logoutInfoAlertEvents: (state) => {
      state.alertEvents = null;
      state.notificationsCount = [];
      state.isFetching = false;
      state.error = false;
    },
  },
});

export const {
  alertEventsStart,
  alertEventsSuccess,
  notificationsCountSuccess,
  alertEventsFailure,
  logoutInfoAlertEvents,
} = alertEventsSlice.actions;

export default alertEventsSlice.reducer;
